import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Loading from '../shared/Loading'
import { useHistory } from 'react-router-dom'
import { verifyEmail } from '../../actions/authAction'
import { useDispatch, useSelector } from 'react-redux';
// import logo from '../../assets/icons/MetaBrief_horizontal_RBG.jpg'

const EmailConfirmation = (props) => {

  const history = useHistory();
  const dispatch = useDispatch();
  const { loading } = useSelector(state => state.verifyEmail)
  useEffect(() => {
    const { id, type } = props.match.params
    const vergicationCode = {
      id,
      type
    }
    dispatch(verifyEmail(vergicationCode, history))
  }, [dispatch, history])

  return (
    <div className='confirm'>
      {loading
        ? <Loading />
        : <Link to='/'>
          <Loading />
        </Link>
      }
    </div>
  );
}
export default EmailConfirmation;
